import { injectable } from 'inversify'

@injectable()
export class Config {
  apiUrl: string = import.meta.env.VITE_API_URL ?? 'http://localhost:4000'

  /**
   * Gates the fixture routes and nav group (Books, "People (demo)",
   * Clickable/Expandable/Columns trees, Infra Demo) behind the same
   * `requiresDemoSurface` mechanism `requiresAdminMode` already uses for
   * admin — see `router.ts`'s `planTarget` and `NavigationPresenter.getChildren`.
   * Guest sign-in is a real product path, not part of this surface — it
   * stays available regardless of this flag.
   *
   * On only when `VITE_SHOW_DEMO_SURFACE` explicitly says `'true'` — not a
   * `DEV`-mode fallback. `npm run dev` without the var set gets the real
   * product surface, same as a production build; a developer who wants the
   * fixtures locally sets it in an untracked `.env.development.local`. The
   * test suite sets it `true` once, globally, in `vite.config.ts`'s own
   * `test.env` — see `demo-surface.infra.test.ts` for the one place that
   * overrides it back to `false`.
   */
  showDemoSurface: boolean = import.meta.env.VITE_SHOW_DEMO_SURFACE === 'true'
}
